import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { FilterObj } from '../CommonComponents/globalfilterObj';
import { getCookie } from "../../services/Cookies";
export default function Bunkeredcity(props) {
  
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [sampleStatus, setSampleSattus] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const autoTextBunkeredCity = async(event) => {
        //
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/BunkerPort/${searchStr}`;

        await getRequest(url)
            .then((res) => {
               
                if (res.status == 200) {
                    let data   = res?.data || [];
                    let result = data?.map((a, i) => { 
                        return { id: a?.portName, name: a?.portName };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setSampleSattus(result);
                } else {
                   // ToastError(res.data.message);
                }
            })
            .catch((error) => {
                
               // ToastError(error.response.data.message);
            });
       
    }
    const handleChange=(event,newValue)=>{
        //
        props.onChange(newValue)
        const filteredFqtbunkerport = {
            ...formObj,
            Fqtbunkercity: newValue
        };
        setFormObj(filteredFqtbunkerport);
        setselectedvalue(newValue);
        setValue("");
    }
    const defaultValue = (val) => {
        ////
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Fqtbunkercity);
            console.log('getcookievalue',formObj)
        }else{
            setFormObj({});
        }
      }
    React.useEffect(() => {
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.Fqtbunkercity || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={sampleStatus}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                onChange={(event, newValue) => handleChange(event,newValue)}
                inputValue={filteredString}
                
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Bunkered City"
                        //placeholder="Favorites"
                        onChange={autoTextBunkeredCity}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
